'use client';

import React from 'react';

interface CloverPaymentButtonProps {
  href: string;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  children: React.ReactNode;
}

const CloverPaymentButton: React.FC<CloverPaymentButtonProps> = ({
  href,
  backgroundColor,
  borderColor,
  textColor,
  children
}) => {
  return (
    <a data-component-id="src/app/service-booking/components/CloverPaymentButton.tsx:21:4" data-component-path="src/app/service-booking/components/CloverPaymentButton.tsx" data-component-line="21" data-component-file="CloverPaymentButton.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22className%22%3A%22block%20text-center%20transition-all%20duration-200%20hover%3Ascale-105%22%7D"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block text-center transition-all duration-200 hover:scale-105"
      style={{
        backgroundColor,
        border: `1px solid ${borderColor}`,
        minHeight: '50px',
        color: textColor,
        padding: '10px 20px',
        textDecoration: 'none',
        borderRadius: '4px',
        fontWeight: 'bold',
        fontSize: '16px',
        margin: '12px auto',
        maxWidth: '400px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {children}
    </a>
  );
};

export default CloverPaymentButton;